import { faker } from '@faker-js/faker';
import { Route } from '../types';

export const fakeRouteFactory = {
  fakeRoute: (): Route => ({
    sections: [
      {
        polyline:
          'BPgoio_mxhy1qDgtu5v1o8vlhB_st3h_2wy6bgkvlm39s402B_pi0ijkrtn2Fnzstx2ynljkEggorz2_hkh3Jow8tv26tum1D',
        summary: {
          duration: faker.datatype.number(),
          length: faker.datatype.number(),
          consumption: faker.datatype.number(),
          co2Emission: faker.datatype.number(),
        },
        aggregateTolls: [],
      },
    ],
  }),
};
